interface Properties {
  width?: number;
  height?: number;
  color?: string;
}

/** Exact file-download asset from the Dashboard header Figma frame (76184:5977). */
const FigmaFileDownloadIcon = ({ width = 16, height = 16, color = '#8B5CF6' }: Properties) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g>
        <path
          d='M9.33301 4.6771V0.316432C9.94167 0.547099 10.5017 0.902432 10.9763 1.37643L13.299 3.70043C13.7737 4.17443 14.129 4.73443 14.3597 5.3431H9.99967C9.63167 5.3431 9.33301 5.04443 9.33301 4.6771ZM14.6503 6.6771H9.99967C8.89701 6.6771 7.99967 5.77977 7.99967 4.6771V0.0257656C7.89234 0.0184323 7.78501 0.00976562 7.67634 0.00976562H4.66634C2.82834 0.0104323 1.33301 1.50577 1.33301 3.34377V12.6771C1.33301 14.5151 2.82834 16.0104 4.66634 16.0104H11.333C13.171 16.0104 14.6663 14.5151 14.6663 12.6771V7.00043C14.6663 6.89177 14.6577 6.78443 14.6503 6.6771ZM10.471 12.3478L9.39567 13.4238C9.01101 13.8084 8.50501 14.0011 7.99967 14.0011C7.49434 14.0011 6.98834 13.8084 6.60367 13.4238L5.52834 12.3478C5.26767 12.0871 5.26767 11.6651 5.52834 11.4051C5.78901 11.1444 6.21034 11.1444 6.47101 11.4051L7.33301 12.2671V9.3351C7.33301 8.9671 7.63101 8.66843 7.99967 8.66843C8.36834 8.66843 8.66634 8.9671 8.66634 9.3351V12.2671L9.52834 11.4051C9.78901 11.1444 10.2103 11.1444 10.471 11.4051C10.7317 11.6651 10.7317 12.0871 10.471 12.3478Z'
          fill={color}
        />
      </g>
    </svg>
  );
};

export default FigmaFileDownloadIcon;
